import axios from "axios";
import { FETCH_ALL_NOTIFICATION_API } from "../Constants/Apis";

export const getNotifications = async () => {
  try {
    return axios.get(`${FETCH_ALL_NOTIFICATION_API}`);
  } catch (e) {
    return console.log(e);
  }
};

export const updateNotificationStatus = async (id, status) => {
  try {
    const response = await axios.patch(
      `${FETCH_ALL_NOTIFICATION_API}/${id}/status`,
      { status },
      
    );
    return response;
  } catch (error) {
    console.error('Error updating notification status:', error);
    throw error;
  }
};
